// extracted by mini-css-extract-plugin
export default {"root":"styles_root__5cfOY","title":"styles_title__PoiLz","info":"styles_info__xsu5f","blue":"styles_blue__XtkQh"};